(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-search"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.ss_site_id) return;

    let debounceTimeout;
    let currentSuggestions = [];
    let trendingQueries = [];
    let trendingDataPromise = null;
    let rotatingPlaceholderInterval = null;
    let currentTrendingIndex = 0;
    let isTyping = false;
    let isShowingDefaultProducts = false;
    const queryCache = new Map();
    const autocompleteCache = new Map();

    const { ss_site_id } = window;
    const moneyFormat = window.shopMoneyFormat;

    const formatMoney = (price) => {
      const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
      let cents;
      if (rate !== 1) {
        const raw = parseFloat(price) * rate;
        cents = Math.ceil(parseFloat(raw.toFixed(2)));
      } else {
        cents = parseFloat(price);
      }
      const amount = cents.toFixed(2);
      const amountNoDecimals = cents.toString();
      const amountWithCommaSeparator = amount.replace('.', ',');
      const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithCommaSeparator)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimalsWithCommaSeparator)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    };

    const searchModal = document.querySelector('.js-search-modal');
    const mainSearchInput = document.querySelector('.new-header__main-search');
    const searchInputTriggers = document.querySelectorAll('.js-search-trigger');
    const mobileSearchText = document.querySelector('.js-mobile-search-text');
    const closeModalButton = document.querySelector('.js-new-search-modal-close');
    const searchModalForm = document.querySelector('.new-search-modal__form');
    const searchModalInput = document.querySelector('.js-search-modal-input');
    const desktopSearchInput = document.querySelector('.js-search-desktop-input');
    const searchModalInlineSuggestion = document.querySelector('.js-search-modal-inline-suggestion');
    const desktopInlineSuggestion = document.querySelector('.js-search-desktop-inline-suggestion');
    const autocompleteContainer = document.querySelector('.js-new-search-autocomplete');
    const autocompleteWrapper = document.querySelector('.js-autocomplete-wrapper');
    const autocompleteContent = document.querySelector('.js-autocomplete-content');
    const querySuggestionsContent = document.querySelector('.js-query-suggestions-content');
    const suggestedSearchesTitle = document.querySelector('.js-suggested-searches-title');
    const desktopQuerySuggestionsContent = document.querySelector('.js-desktop-search-recommendations');
    const trendingContainer = document.querySelector('.js-new-searchspring-top');
    const desktopSearchContainer = document.querySelector('[data-search-desktop]');
    const trendingContainerDesktop = document.querySelector('.js-new-searchspring-top-desktop');
    const recentContainer = document.querySelector('.js-new-searchspring-recent');
    const recentContainerDesktop = document.querySelector('.js-new-searchspring-recent-desktop');
    const pageOverlay = document.querySelector('.js-page-overlay');
    const desktopResultsContainer = document.querySelector('.js-new-search-desktop-results');
    const desktopViewAllButton = document.querySelector('.js-new-search-desktop-view-all');
    const desktopSearchInputContainer = document.querySelector('.new-header__search');
    let activeInput, activeInlineSuggestion;
    const announcementBar = document.querySelector('.new-announcement-bar');
    const headerBar = document.querySelector('.new-header');
    const errorMessageContainer = document.querySelector('.js-search-error-message');

    if (!searchModal || !mainSearchInput || !autocompleteContainer || !autocompleteWrapper || !autocompleteContent || !querySuggestionsContent) return;

    const ACTIVE_CLASS = 'new-search-modal--is-active';
    const MAIN_ACTIVE_CLASS = 'new-header__main-search--is-active';
    const AUTOCOMPLETE_ACTIVE_CLASS = 'new-search-autocomplete-container--is-active';
    const OVERLAY_ACTIVE_CLASS = 'is-visible';
    const MOBILE_BREAKPOINT = 768;

    const animateAutocompleteContainer = (show = true) => {
      if (show) {
        requestAnimationFrame(() => {
          const contentHeight = autocompleteWrapper.scrollHeight;
          autocompleteContainer.style.height = `${contentHeight}px`;
          autocompleteContainer.classList.add(AUTOCOMPLETE_ACTIVE_CLASS);

          // Recalculate after images load in case scrollHeight changes
          const images = autocompleteWrapper.querySelectorAll('img:not([complete])');
          images.forEach((img) => {
            if (!img.complete) {
              img.addEventListener('load', () => {
                if (autocompleteContainer.classList.contains(AUTOCOMPLETE_ACTIVE_CLASS)) {
                  autocompleteContainer.style.height = `${autocompleteWrapper.scrollHeight}px`;
                }
              }, { once: true });
            }
          });
        });
      } else {
        autocompleteContainer.style.height = '0px';
        autocompleteContainer.classList.remove(AUTOCOMPLETE_ACTIVE_CLASS);
      }
    };

    const clearSuggestions = () => {
      querySuggestionsContent.innerHTML = '';
      querySuggestionsContent.classList.remove('is-active');
      if (suggestedSearchesTitle) suggestedSearchesTitle.style.display = 'none';
      if (searchModalInlineSuggestion) searchModalInlineSuggestion.value = '';
      if (desktopInlineSuggestion) desktopInlineSuggestion.value = '';
      if (errorMessageContainer) errorMessageContainer.style.display = 'none';
      if (activeInput) activeInput.setAttribute('aria-expanded', 'false');
      currentSuggestions = [];
    };

    const clearAllAutocomplete = () => {
      clearSuggestions();
      autocompleteContent.innerHTML = '';
      if (desktopResultsContainer) desktopResultsContainer.innerHTML = '';
      animateAutocompleteContainer(false);
      if (desktopQuerySuggestionsContent) desktopQuerySuggestionsContent.innerHTML = '';
      if (desktopViewAllButton) {
        desktopViewAllButton.classList.remove('is-visible');
      }
      if (desktopQuerySuggestionsContent?.parentElement) {
        desktopQuerySuggestionsContent.parentElement.classList.remove('is-active');
      }
      if (autocompleteWrapper) {
        autocompleteWrapper.classList.remove('is-loading');
      }
      if (desktopResultsContainer) {
        desktopResultsContainer.classList.remove('is-loading');
      }
    };

    const toTitleCase = (str) => str.replace(/\b\w/g, (c) => c.toUpperCase());

    // Fisher-Yates shuffle for randomising trending order
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };

    const fetchData = async (url, options = {}) => {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    };

    const fetchTrendingData = () => {
      if (!trendingDataPromise) {
        const url = `https://${ss_site_id}.a.searchspring.io/api/suggest/trending?limit=10&siteId=${ss_site_id}`;
        trendingDataPromise = fetchData(url, { headers: { accept: 'application/json' } })
          .then((data) => {
            if (data?.trending?.queries.length > 0) {
              const queries = data.trending.queries.map(({ searchQuery }) => searchQuery);
              trendingQueries = shuffleArray(queries); // Shuffle for random order each page load
            }
            return data;
          })
          .catch((err) => {
            console.error('Error fetching trending searches:', err);
            trendingDataPromise = null;
            throw err;
          });
      }
      return trendingDataPromise;
    };

    const fetchAndDisplayTrending = async (targetElement) => {
      const trending = targetElement || trendingContainer;
      if (!trending) return;

      if (trending.dataset.rendered === 'true') return;

      trending.innerHTML = '<div>Loading...</div>';

      try {
        const data = await fetchTrendingData();

        trending.innerHTML = '';
        if (data?.trending?.queries.length > 0) {
          const fragment = document.createDocumentFragment();
          trendingQueries.forEach((searchQuery) => {
            const listItem = document.createElement('li');
            const link = document.createElement('a');
            link.classList.add('new-link-underline');
            link.href = `/collections/shop?q=${encodeURIComponent(searchQuery)}`;
            link.textContent = toTitleCase(searchQuery);
            listItem.appendChild(link);
            fragment.appendChild(listItem);
          });
          trending.appendChild(fragment);
          trending.dataset.rendered = 'true';
        } else {
          trending.innerHTML = '<div>No top searches available.</div>';
        }
      } catch (err) {
        trending.innerHTML = '<div>Error loading suggestions.</div>';
      }
    };

    // Default products cache
    let defaultProductsCache = null;
    let desktopDefaultNodesCache = null;
    let mobileDefaultNodesCache = null;

    /**
     * Get default Searchspring ID from the appropriate container
     */
    const getDefaultSearchspringId = (isDesktop = false) => {
      const configContainer = isDesktop ? desktopResultsContainer : autocompleteContainer;
      return configContainer?.dataset.defaultSearchspringId || '';
    };

    /**
     * Fetch and display default products when search opens
     */
    const fetchAndDisplayDefaultProducts = async (isDesktop = false) => {
      const targetContainer = isDesktop ? desktopResultsContainer : autocompleteContent;
      if (!targetContainer) return;

      const searchspringId = getDefaultSearchspringId(isDesktop);
      if (!searchspringId) return;

      // Use cached results if available
      if (defaultProductsCache) {
        renderDefaultProducts(defaultProductsCache, isDesktop, targetContainer);
        return;
      }

      try {
        const resultsPerPage = isDesktop ? 4 : 6;
        const url = `https://${ss_site_id}.a.searchspring.io/boost/${ss_site_id}/recommend?tags=${searchspringId}&limits=${resultsPerPage}`;
        const data = await fetchData(url, { headers: { accept: 'application/json' } });

        const products = data?.[0]?.results;
        if (products?.length > 0) {
          defaultProductsCache = products;
          renderDefaultProducts(products, isDesktop, targetContainer);
        }
      } catch (err) {
        console.error('Error fetching default products:', err);
      }
    };

    /**
     * Create a desktop product card element
     */
    const renderDesktopProductCard = (product, index) => {
      const resultLink = document.createElement('a');
      resultLink.href = product.url;
      resultLink.className = 'new-search-desktop__result';
      resultLink.style.transitionDelay = `${index * 60}ms`;

      const image = document.createElement('img');
      image.className = 'new-search-desktop__result-image';
      image.src = product.thumbnailImageUrl || product.imageUrl;
      image.alt = product.name;
      image.loading = 'lazy';

      const titleDiv = document.createElement('div');
      titleDiv.className = 'new-search-desktop__result-title';
      titleDiv.textContent = product.name;

      const priceContainerDiv = document.createElement('div');
      priceContainerDiv.className = 'new-search-desktop__result-prices';

      const priceDiv = document.createElement('div');
      priceDiv.className = 'new-search-desktop__result-price new-search-desktop__result-price--current';
      priceDiv.textContent = formatMoney(product.price);
      priceContainerDiv.appendChild(priceDiv);

      if (product.ss_on_sale === '1' && Number(product.msrp) > Number(product.price)) {
        const msrpDiv = document.createElement('div');
        msrpDiv.className = 'new-search-desktop__result-price new-search-desktop__result-price--msrp';
        msrpDiv.textContent = formatMoney(product.msrp);
        priceContainerDiv.appendChild(msrpDiv);

        if (product.ss_pct_off) {
          const salePercentage = document.createElement('div');
          salePercentage.className = 'new-search-desktop__result-price--sale-percentage';
          salePercentage.textContent = `Save ${product.ss_pct_off}%`;
          priceContainerDiv.appendChild(salePercentage);
        }

        priceContainerDiv.classList.add('new-search-desktop__result-prices--is-on-sale');
      }

      if (product.ss_badge_bg && product.ss_badge_colour && product.ss_badge_text) {
        const badgeContainerDiv = document.createElement('div');
        badgeContainerDiv.className = 'new-search-desktop__result-badges js-new-search-desktop-badges';

        const badgeDiv = document.createElement('div');
        badgeDiv.className = 'new-search-desktop__result-badge';
        badgeDiv.textContent = product.ss_badge_text;
        badgeDiv.style.backgroundColor = product.ss_badge_bg;
        badgeDiv.style.color = product.ss_badge_colour;

        badgeContainerDiv.appendChild(badgeDiv);
        resultLink.appendChild(badgeContainerDiv);
      }

      resultLink.appendChild(image);
      resultLink.appendChild(titleDiv);
      resultLink.appendChild(priceContainerDiv);

      return resultLink;
    };

    /**
     * Create a mobile product card element
     */
    const renderMobileProductCard = (product, index) => {
      const link = document.createElement('a');
      link.href = product.url;
      link.className = 'new-search-autocomplete-container__product-link';
      link.style.transitionDelay = `${index * 50}ms`;

      const image = document.createElement('img');
      image.src = product.imageUrl;
      image.alt = product.name;
      image.loading = 'lazy';

      const titleEl = document.createElement('span');
      titleEl.className = 'product-link__title';
      titleEl.textContent = product.name;

      const priceEl = document.createElement('span');
      priceEl.className = 'product-link__price';
      priceEl.textContent = formatMoney(product.price);

      link.appendChild(image);
      link.appendChild(titleEl);
      link.appendChild(priceEl);
      return link;
    };

    /**
     * Render default products to the appropriate container
     */
    const renderDefaultProducts = (products, isDesktop = false, targetContainer) => {
      if (!products || !products.length || !targetContainer) return;

      targetContainer.innerHTML = '';
      isShowingDefaultProducts = true;

      if (isDesktop) {
        if (!desktopDefaultNodesCache) {
          desktopDefaultNodesCache = products.map((product, index) => {
            const flatProduct = { ...product.mappings.core, ...product.attributes, id: product.id };
            const card = renderDesktopProductCard(flatProduct, index);
            card.classList.add('new-search-desktop__result--default');
            return card;
          });
        }

        const fragment = document.createDocumentFragment();
        desktopDefaultNodesCache.forEach(node => {
          node.classList.remove('is-visible');
          fragment.appendChild(node);
        });
        targetContainer.appendChild(fragment);

        // Trigger staggered animation
        requestAnimationFrame(() => {
          desktopDefaultNodesCache.forEach((el, i) => {
            el.style.transitionDelay = `${i * 60}ms`;
            el.classList.add('is-visible');
          });
        });
      } else {
        if (!mobileDefaultNodesCache) {
          const resultsContainer = document.createElement('div');
          resultsContainer.className =
            'new-search-autocomplete-container__results new-search-autocomplete-container__results--default';

          products.forEach((product, index) => {
            const flatProduct = { ...product.mappings.core, ...product.attributes, id: product.id };
            resultsContainer.appendChild(renderMobileProductCard(flatProduct, index));
          });
          mobileDefaultNodesCache = resultsContainer;
        }

        targetContainer.appendChild(mobileDefaultNodesCache);
        if (autocompleteContainer) animateAutocompleteContainer(true);
      }
    };
    // Rotating placeholder animation functions
    const DEFAULT_SEARCH_TEXT = 'Search';
    const PLACEHOLDER_PREFIX = DEFAULT_SEARCH_TEXT + ' ';
    const PLACEHOLDER_SUFFIX = '...';
    const BASE_TYPING_SPEED = 60;
    const TYPING_SPEED_VARIANCE = 25;
    const BASE_ERASING_SPEED = 30;
    const ERASING_SPEED_VARIANCE = 15;
    const AUTO_SEARCH_ON_CLICK = false; // Set to false to disable auto-search when clicking with visible suggestion
    let currentSuggestionText = '';
    let isPaused = false;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateSearchText = (text) => {
      if (desktopSearchInput) {
        desktopSearchInput.setAttribute('placeholder', text);
      }
      if (mobileSearchText) {
        mobileSearchText.setAttribute('data-search-text', text);
      }
    };

    const typeText = (text, callback) => {
      let charIndex = 0;
      const fullText = text + PLACEHOLDER_SUFFIX;
      isTyping = true;

      const typeChar = () => {
        if (!isTyping) return;

        if (isPaused) {
          rotatingPlaceholderInterval = setTimeout(typeChar, 100);
          return;
        }

        if (charIndex < fullText.length) {
          const displayText = PLACEHOLDER_PREFIX + fullText.substring(0, charIndex + 1);
          updateSearchText(displayText);
          charIndex++;
          // Variable typing speed for natural feel
          const variance = Math.floor(Math.random() * TYPING_SPEED_VARIANCE * 2) - TYPING_SPEED_VARIANCE;
          rotatingPlaceholderInterval = setTimeout(typeChar, BASE_TYPING_SPEED + variance);
        } else {
          rotatingPlaceholderInterval = setTimeout(callback, 2000);
        }
      };

      typeChar();
    };

    const clearText = (text, callback) => {
      const fullText = text + PLACEHOLDER_SUFFIX;
      let charIndex = fullText.length;

      const eraseChar = () => {
        if (isTyping) return;

        if (isPaused) {
          rotatingPlaceholderInterval = setTimeout(eraseChar, 100);
          return;
        }

        if (charIndex > 0) {
          const displayText = PLACEHOLDER_PREFIX + fullText.substring(0, charIndex - 1);
          updateSearchText(displayText);
          charIndex--;
          // Variable erasing speed for natural feel
          const variance = Math.floor(Math.random() * ERASING_SPEED_VARIANCE * 2) - ERASING_SPEED_VARIANCE;
          rotatingPlaceholderInterval = setTimeout(eraseChar, BASE_ERASING_SPEED + variance);
        } else {
          rotatingPlaceholderInterval = setTimeout(callback, 300);
        }
      };

      eraseChar();
    };

    const rotateToNextTrending = (inputEl) => {
      if (!inputEl || trendingQueries.length === 0 || inputEl.value?.trim() !== '') {
        return;
      }

      const nextQuery = trendingQueries[currentTrendingIndex];
      const displayText = toTitleCase(nextQuery);
      currentSuggestionText = displayText;

      typeText(displayText, () => {
        if (inputEl.value?.trim() === '') {
          isTyping = false;
          clearText(displayText, () => {
            currentSuggestionText = '';
            currentTrendingIndex = (currentTrendingIndex + 1) % trendingQueries.length;
            if (inputEl.value?.trim() === '') {
              rotateToNextTrending(inputEl);
            }
          });
        }
      });
    };

    const startRotatingPlaceholder = (inputEl, resetIndex = false) => {
      stopRotatingPlaceholder();
      currentSuggestionText = '';
      isPaused = false;

      if (!inputEl || trendingQueries.length === 0 || inputEl.value?.trim() !== '') {
        return;
      }

      // Respect user's motion preferences
      if (prefersReducedMotion) {
        const displayText =
          PLACEHOLDER_PREFIX + toTitleCase(trendingQueries[currentTrendingIndex]) + PLACEHOLDER_SUFFIX;
        updateSearchText(displayText);
        currentSuggestionText = toTitleCase(trendingQueries[currentTrendingIndex]);
        return;
      }

      // Only reset index on initial page load, not when closing/reopening search
      if (resetIndex) {
        currentTrendingIndex = 0;
      }
      rotateToNextTrending(inputEl);
    };

    const stopRotatingPlaceholder = () => {
      isTyping = false;
      isPaused = false;
      clearTimeout(rotatingPlaceholderInterval);
      rotatingPlaceholderInterval = null;
    };

    const pauseRotatingPlaceholder = () => {
      isPaused = true;
    };

    const resumeRotatingPlaceholder = () => {
      isPaused = false;
    };

    const clearPlaceholder = () => {
      stopRotatingPlaceholder();
      currentSuggestionText = '';
      updateSearchText('');
    };

    const displayRecentSearches = (targetElement) => {
      const recent = targetElement || recentContainer;
      if (!recent) return;

      recent.innerHTML = '';
      let recentSearches = [];
      try {
        const historyString = localStorage.getItem('ss-history');
        if (historyString) {
          const { history } = JSON.parse(historyString);
          if (typeof history === 'string') {
            recentSearches = JSON.parse(history);
          }
        }
      } catch (err) {
        console.error('Error parsing recent searches:', err);
      }

      if (recentSearches.length > 0) {
        const fragment = document.createDocumentFragment();
        recentSearches.slice(0, 6).forEach((search) => {
          const listItem = document.createElement('li');
          const link = document.createElement('a');
          link.classList.add('new-link-underline');
          link.href = `/collections/shop?q=${encodeURIComponent(search)}`;
          link.textContent = toTitleCase(search);
          listItem.appendChild(link);
          fragment.appendChild(listItem);
        });
        recent.appendChild(fragment);
      } else {
        recent.innerHTML = '<div>No recent searches.</div>';
      }
    };

    const fetchAndDisplayQuerySuggestions = async (query) => {
      try {
        if (errorMessageContainer) errorMessageContainer.style.display = 'none';
        
        const url = `https://${ss_site_id}.a.searchspring.io/api/suggest/query?siteId=${ss_site_id}&q=${encodeURIComponent(
          query
        )}&limit=4`;
        
        if (activeInput && activeInput.value.trim() !== query) return;

        let data;
        if (queryCache.has(url)) {
          data = queryCache.get(url);
        } else {
          data = await fetchData(url);
          queryCache.set(url, data);
        }

        if (activeInput && activeInput.value.trim() !== query) return;

        clearSuggestions();

        let suggestions = [];
        if (data.suggested?.text) suggestions.push(data.suggested);
        if (Array.isArray(data.alternatives)) suggestions = suggestions.concat(data.alternatives);
        currentSuggestions = suggestions.slice(0, 4);

        if (currentSuggestions.length > 0) {
          let suggestionForInline = '';
          const firstSuggestionText = currentSuggestions[0].text;
          const queryLower = query.toLowerCase();

          // If the top suggestion is an exact match for the query, try to use the second suggestion for the inline text.
          if (firstSuggestionText.toLowerCase() === queryLower && currentSuggestions.length > 1) {
            suggestionForInline = currentSuggestions[1].text;
          } else {
            suggestionForInline = firstSuggestionText;
          }

          // Set the inline suggestion value only if it's a valid completion (and not an exact match).
          if (activeInlineSuggestion) {
            if (
              suggestionForInline.toLowerCase().startsWith(queryLower) &&
              suggestionForInline.toLowerCase() !== queryLower
            ) {
              activeInlineSuggestion.value = suggestionForInline;
            }
          }

          const isDesktop = activeInput === desktopSearchInput;
          const targetContainer = isDesktop ? desktopQuerySuggestionsContent : querySuggestionsContent;

          if (targetContainer) {
            targetContainer.innerHTML = '';
            const fragment = document.createDocumentFragment();

            currentSuggestions.forEach(({ text }) => {
              let element;
              if (isDesktop) {
                element = document.createElement('li');
                const link = document.createElement('a');
                link.href = `/collections/shop?q=${encodeURIComponent(text)}`;
                link.textContent = toTitleCase(text);
                link.classList.add('new-link-underline');
                element.appendChild(link);
              } else {
                element = document.createElement('li');
                const link = document.createElement('a');
                link.href = `/collections/shop?q=${encodeURIComponent(text)}`;
                link.textContent = text;
                link.className = 'query-suggestion-item';
                element.appendChild(link);
              }
              fragment.appendChild(element);
            });

            targetContainer.appendChild(fragment);
            if (isDesktop) {
              targetContainer.parentElement.classList.add('is-active');
            } else {
              targetContainer.classList.add('is-active');
              if (suggestedSearchesTitle) suggestedSearchesTitle.style.display = 'block';
            }
          }
        }
      } catch (error) {
        console.error('Error fetching query suggestions:', error);
        if (errorMessageContainer) {
          errorMessageContainer.textContent = 'Unable to load search suggestions. Please try again.';
          errorMessageContainer.style.display = 'block';
        }
      }
    };

    const fetchAndDisplayAutocomplete = async (query) => {
      try {
        if (errorMessageContainer) errorMessageContainer.style.display = 'none';
        
        const isDesktop = activeInput === desktopSearchInput;
        const resultsPerPage = isDesktop ? 4 : 6;
        const url = `https://${ss_site_id}.a.searchspring.io/api/search/autocomplete.json?siteId=${ss_site_id}&resultsFormat=json&resultsPerPage=${resultsPerPage}&q=${encodeURIComponent(
          query
        )}`;
        
        if (activeInput && activeInput.value.trim() !== query) return;

        let data;
        if (autocompleteCache.has(url)) {
          data = autocompleteCache.get(url);
        } else {
          data = await fetchData(url, { headers: { accept: 'application/json' } });
          autocompleteCache.set(url, data);
        }

        if (activeInput && activeInput.value.trim() !== query) return;

        autocompleteContent.innerHTML = '';
        if (desktopResultsContainer) desktopResultsContainer.innerHTML = '';

        if (data?.results?.length > 0) {
          if (isDesktop && desktopResultsContainer) {
            const fragment = document.createDocumentFragment();
            data.results.forEach((product, index) => {
              fragment.appendChild(renderDesktopProductCard(product, index));
            });
            desktopResultsContainer.appendChild(fragment);

            // Trigger staggered animation after elements are in the DOM
            requestAnimationFrame(() => {
              desktopResultsContainer.querySelectorAll('.new-search-desktop__result').forEach((el) => {
                el.classList.add('is-visible');
              });
            });
          } else {
            const resultsContainer = document.createElement('div');
            resultsContainer.className = 'new-search-autocomplete-container__results';

            data.results.forEach((product, index) => {
              resultsContainer.appendChild(renderMobileProductCard(product, index));
            });

            autocompleteContent.appendChild(resultsContainer);

            const viewAllLink = document.createElement('a');
            viewAllLink.href = `/collections/shop?q=${encodeURIComponent(query)}`;
            viewAllLink.className = 'new-search-autocomplete-container__view-all';
            viewAllLink.textContent = `View all results (${data.pagination.totalResults})`;
            viewAllLink.insertAdjacentHTML(
              'beforeend',
              `<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><polyline points="4,2 8,6 4,10" fill="none" stroke="currentColor" stroke-width="1"/></svg>`
            );
            autocompleteContent.appendChild(viewAllLink);
          }

          if (desktopViewAllButton) {
            desktopViewAllButton.textContent = `View all results (${data.pagination.totalResults})`;
            desktopViewAllButton.href = `/collections/shop?q=${encodeURIComponent(query)}`;
            desktopViewAllButton.classList.add('is-visible');
          }
          
          if (activeInput) {
             const resultsCount = data?.pagination?.totalResults || 0;
             activeInput.setAttribute('aria-expanded', 'true');
             
             // Announce to screen readers that results are loaded
             if (autocompleteContainer) {
               autocompleteContainer.setAttribute('aria-label', `${resultsCount} results found.`);
             }
          }
          
        } else {
          // Hide the view all button when there are no results
          if (desktopViewAllButton) {
            desktopViewAllButton.classList.remove('is-visible');
          }
        }
      } catch (err) {
        console.error('Error fetching autocomplete:', err);
        if (errorMessageContainer) {
           errorMessageContainer.textContent = 'Unable to load search results. Please try again.';
           errorMessageContainer.style.display = 'block';
        }
      }
    };

    const openSearchModal = () => {
      const isHeaderSticky = headerBar?.classList.contains('new-header--is-sticky');
      const suggestionToSearch =
        AUTO_SEARCH_ON_CLICK && currentSuggestionText && !isHeaderSticky ? currentSuggestionText : '';

      // Clear the rotating placeholder when opening search
      if (desktopSearchInput) {
        clearPlaceholder();
      }

      document.body.classList.add('search-is-active');
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        searchModal.classList.add(ACTIVE_CLASS);
        if (announcementBar) announcementBar.classList.add('is-hover');
        mainSearchInput.classList.add(MAIN_ACTIVE_CLASS);
        window.scrollUtils.disableScroll();
        fetchAndDisplayTrending(trendingContainer);
        displayRecentSearches(recentContainer);
        activeInput = searchModalInput;
        activeInlineSuggestion = searchModalInlineSuggestion;
        searchModalInput.focus();

        // Auto-search if suggestion was visible (search but don't fill input)
        if (suggestionToSearch) {
          // Show the autocomplete container and fetch results
          if (autocompleteContainer) animateAutocompleteContainer(true);
          fetchAndDisplayAutocomplete(suggestionToSearch);
        } else {
          // Show default products if no auto-search
          fetchAndDisplayDefaultProducts(false);
        }
      } else {
        if (desktopSearchContainer) {
          desktopSearchContainer.classList.add('new-search-desktop--is-active');
          fetchAndDisplayTrending(trendingContainerDesktop);
          displayRecentSearches(recentContainerDesktop);
          if (pageOverlay) pageOverlay.classList.add(OVERLAY_ACTIVE_CLASS);
          window.scrollUtils.disableScroll();
          activeInput = desktopSearchInput;
          desktopSearchInputContainer.classList.add('is-active-desktop');
          activeInlineSuggestion = desktopInlineSuggestion;
          if (headerBar) headerBar.classList.add('is-hover');
          if (announcementBar) announcementBar.classList.add('is-hover');

          if (suggestionToSearch) {
            fetchAndDisplayAutocomplete(suggestionToSearch);
          } else {
            fetchAndDisplayDefaultProducts(true);
          }

          desktopSearchContainer.addEventListener('transitionend', () => {
            if (!activeInput) return;
            activeInput.focus();
          }, { once: true });
        }
      }
    };

    // Pre-fetch defaults on load for snappier experience
    setTimeout(() => {
      fetchAndDisplayDefaultProducts(false);
      fetchAndDisplayDefaultProducts(true);
    }, 2000);

    const closeSearchModal = () => {
      // DEBUGGING IN BROWSER:
      // window.searchDebug = true;
      if (window.searchDebug) {
        console.log('Search close prevented (debug mode). Set window.searchDebug = false to disable.');
        return;
      }

      document.body.classList.remove('search-is-active');
      searchModal.classList.remove(ACTIVE_CLASS);
      if (announcementBar) announcementBar.classList.remove('is-hover');
      if (headerBar) headerBar.classList.remove('is-hover');
      mainSearchInput.classList.remove(MAIN_ACTIVE_CLASS);
      window.scrollUtils.enableScroll();
      if (desktopSearchContainer) desktopSearchContainer.classList.remove('new-search-desktop--is-active');
      if (desktopSearchInputContainer) desktopSearchInputContainer.classList.remove('is-active-desktop');
      if (searchModalInput) {
        searchModalInput.value = '';
        searchModalInput.blur();
      }
      if (desktopSearchInput) {
        desktopSearchInput.value = '';
        desktopSearchInput.blur();
      }
      clearAllAutocomplete();
      isShowingDefaultProducts = false;
      if (pageOverlay) pageOverlay.classList.remove(OVERLAY_ACTIVE_CLASS);
      activeInput = null;
      activeInlineSuggestion = null;

      // Restart rotating placeholder with next suggestion (increment index so user sees fresh content)
      if (trendingQueries.length > 0) {
        currentTrendingIndex = (currentTrendingIndex + 1) % trendingQueries.length;
      }
      startRotatingPlaceholder(desktopSearchInput);
    };

    window.closeSearchModal = closeSearchModal;

    const handleSearchSubmit = (event) => {
      event.preventDefault();
      if (!activeInput) return;
      const searchTerm = activeInput.value.trim();
      if (!searchTerm) return;

      let recentSearches = [];
      try {
        const historyString = localStorage.getItem('ss-history');
        if (historyString) {
          recentSearches = JSON.parse(JSON.parse(historyString).history);
        }
      } catch (err) {
        console.error('Could not parse search history:', err);
      }

      const updatedSearches = [
        searchTerm,
        ...recentSearches.filter((s) => s.toLowerCase() !== searchTerm.toLowerCase()),
      ].slice(0, 20);
      const historyToSave = { history: JSON.stringify(updatedSearches) };
      localStorage.setItem('ss-history', JSON.stringify(historyToSave));

      window.location.href = `/collections/shop?q=${encodeURIComponent(searchTerm)}`;
    };

    const handleSearchInput = () => {
      clearTimeout(debounceTimeout);
      if (!activeInput) return;
      const query = activeInput.value.trim();

      // Stop rotating placeholder when typing
      if (query.length > 0) {
        stopRotatingPlaceholder();
      }

      if (query.length < 2) {
        clearAllAutocomplete();
        // Restart rotating placeholder if input cleared
        if (query.length === 0 && activeInput) {
          startRotatingPlaceholder(activeInput);
        }
        return;
      }

      if (activeInlineSuggestion) {
        const inlineSuggestion = activeInlineSuggestion.value;
        if (inlineSuggestion && !inlineSuggestion.toLowerCase().startsWith(query.toLowerCase())) {
          activeInlineSuggestion.value = '';
        }
      }

      if (autocompleteWrapper) autocompleteWrapper.classList.add('is-loading');
      
      // When loading starts, animate the container open slightly so the absolute spinner has room to be visible
      // without pushing content down by 220px. 60px provides enough room for the spinner.
      if (autocompleteContainer) {
         requestAnimationFrame(() => {
           // Only expand if we have 0 height (meaning no previous results are showing)
           if (autocompleteContainer.style.height === '' || autocompleteContainer.style.height === '0px') {
             autocompleteContainer.style.height = '60px';
             autocompleteContainer.classList.add(AUTOCOMPLETE_ACTIVE_CLASS);
           }
         });
      }
      
      if (desktopResultsContainer) desktopResultsContainer.classList.add('is-loading');

      debounceTimeout = setTimeout(async () => {
        if (activeInput && activeInput.value.trim() !== query) return;

        await Promise.all([fetchAndDisplayQuerySuggestions(query), fetchAndDisplayAutocomplete(query)]);

        if (activeInput && activeInput.value.trim() !== query) return;

        const hasSuggestions = querySuggestionsContent.hasChildNodes() || autocompleteContent.hasChildNodes() || (errorMessageContainer && errorMessageContainer.style.display === 'block');
        
        // Remove loading state before animating so `scrollHeight` calculations are accurate
        autocompleteWrapper.classList.remove('is-loading');
        if (desktopResultsContainer) desktopResultsContainer.classList.remove('is-loading');
        
        animateAutocompleteContainer(hasSuggestions);
      }, 350);
    };

    const handleKeyDown = (e) => {
      if (!activeInput) return;
      if ((e.key === 'Tab' || e.key === 'ArrowRight') && activeInlineSuggestion?.value) {
        if (activeInput.selectionStart === activeInput.value.length) {
          e.preventDefault();
          activeInput.value = activeInlineSuggestion.value;
          clearSuggestions();
          fetchAndDisplayAutocomplete(activeInput.value);
        }
      } else if (e.key === 'Enter') {
        e.preventDefault();
        // The desktop input isn't in a form, so we manually trigger the logic.
        const form = activeInput.closest('form');
        form ? form.requestSubmit() : handleSearchSubmit(e);
      }
    };

    const handleKeyUp = (e) => {
      if (
        e.key === 'Escape' &&
        (searchModal.classList.contains(ACTIVE_CLASS) ||
          desktopSearchContainer?.classList.contains('new-search-desktop--is-active'))
      ) {
        closeSearchModal();
      }
    };

    searchInputTriggers.forEach((trigger) => trigger.addEventListener('click', openSearchModal));
    closeModalButton?.addEventListener('click', closeSearchModal);
    searchModalForm?.addEventListener('submit', handleSearchSubmit);
    searchModalInput?.addEventListener('input', handleSearchInput);
    searchModalInput?.addEventListener('keydown', handleKeyDown);
    desktopSearchInput?.addEventListener('input', handleSearchInput);
    desktopSearchInput?.addEventListener('keydown', handleKeyDown);

    document.addEventListener('keyup', handleKeyUp);

    // Close search when clicking the page overlay
    if (pageOverlay) {
      pageOverlay.addEventListener('click', () => {
        const isDesktopSearchOpen = desktopSearchContainer?.classList.contains('new-search-desktop--is-active');
        const isMobileSearchOpen = searchModal?.classList.contains(ACTIVE_CLASS);
        if (isDesktopSearchOpen || isMobileSearchOpen) {
          closeSearchModal();
        }
      });
    }

    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('mouseenter', pauseRotatingPlaceholder);
      desktopSearchInput.addEventListener('mouseleave', resumeRotatingPlaceholder);
    }
    if (mobileSearchText) {
      mobileSearchText.addEventListener('mouseenter', pauseRotatingPlaceholder);
      mobileSearchText.addEventListener('mouseleave', resumeRotatingPlaceholder);
    }

    const initRotatingPlaceholder = async () => {
      // Works on both desktop and mobile - updateSearchText handles both
      if (!desktopSearchInput && !mobileSearchText) return;

      try {
        await fetchTrendingData();
        if (trendingQueries.length > 0) {
          startRotatingPlaceholder(desktopSearchInput, true);
        }
      } catch (err) {
        console.error('Error initializing rotating placeholder:', err);
      }
    };

    // Pause placeholder animation when header is sticky (search bar hidden)
    if (headerBar) {
      const stickyObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const isSticky = headerBar.classList.contains('new-header--is-sticky');
            if (isSticky) {
              pauseRotatingPlaceholder();
            } else {
              resumeRotatingPlaceholder();
            }
          }
        });
      });
      stickyObserver.observe(headerBar, { attributes: true, attributeFilter: ['class'] });
    }

    initRotatingPlaceholder();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["new-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    const debounce = (func, wait = 100) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    class SeamlessSlider {
      constructor(section) {
        this.section = section;
        this.container = section.querySelector('.js-slider');
        this.totalEl = section.querySelector('.js-slider-total');

        const slideCountFromLiquid = this.totalEl ? parseInt(this.totalEl.textContent, 10) : NaN;
        this.originalSlides = this.container ? Array.from(this.container.children) : [];
        this.totalSlides =
          !isNaN(slideCountFromLiquid) && slideCountFromLiquid > 0
            ? slideCountFromLiquid
            : this.originalSlides.length || 0;

        this.dots = section.querySelectorAll('.js-slider-dot');
        const countContainer = Array.from(section.children).find((el) => el.classList.contains('slider__count'));
        this.currentEl = countContainer?.querySelector('.js-slider-current');
        this.totalEl = countContainer?.querySelector('.js-slider-total');
        this.prevButton = section.querySelector(':scope > .js-slider-prev');
        this.nextButton = section.querySelector(':scope > .js-slider-next');

        this.alignLeft = section.dataset.sliderAlignLeft === 'true';
        this.alignLeftMobile = section.dataset.sliderAlignLeftMobile === 'true';
        this.slidesToShow = parseFloat(getComputedStyle(this.section).getPropertyValue('--slides-to-show')) || 1;

        // Check if we have enough slides to scroll (use actual decimal value)
        const hasEnoughSlidesToScroll = this.originalSlides.length > this.slidesToShow;

        // If not enough slides to scroll, disable everything and mark as initialized
        if (!hasEnoughSlidesToScroll) {
          section.classList.add('is-initialised', 'slider--no-scroll');
          if (this.prevButton) this.prevButton.style.display = 'none';
          if (this.nextButton) this.nextButton.style.display = 'none';
          // Mark all slides as active so they display properly
          this.originalSlides.forEach((slide) => {
            slide.classList.add('is-active');
            // Load all images (both with and without src)
            const images = slide.querySelectorAll('img[data-src]');
            images.forEach((image) => {
              if (image.dataset.src && !image.src) {
                image.src = image.dataset.src;
              }
            });
          });
          // Initialise any inner sliders (e.g., product card image sliders)
          const innerSliders = section.querySelectorAll('[data-slider-component]:not([data-slider-initialised])');
          innerSliders.forEach((slider) => initSlider(slider));
          return;
        }

        this.disableDrag = section.dataset.sliderDisableDrag === 'true';

        // Auto-disable cloning when there aren't enough EXTRA slides beyond what's visible
        // This prevents duplicate products and enables edge-stopping behavior
        // We need at least (ceil(slidesToShow) + 1) extra slides for seamless cloning
        this.shouldClone = this.originalSlides.length > Math.ceil(this.slidesToShow) * 2;
        this.numClones = this.shouldClone ? Math.min(this.originalSlides.length, Math.ceil(this.slidesToShow) + 1) : 0;

        // Calculate max scroll index for non-cloning sliders
        // This limits scrolling so the last slide is just visible on the right edge
        this.maxScrollIndex = this.shouldClone 
          ? Infinity 
          : Math.max(0, this.originalSlides.length - Math.floor(this.slidesToShow));

        this.currentIndex = this.numClones; // Starts at 0 if no cloning
        this.currentTranslate = 0;
        this.prevTranslate = 0;

        // Drag state
        this.isDragging = false;
        this.startX = 0;
        this.startY = 0;
        this.dragDelta = 0;
        this.isLocked = false;
        this.isAnimating = false;
        this.wasDragged = false;

        // Bound methods
        this._onTouchStart = this._onTouchStart.bind(this);
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
        this._onTouchCancel = this._onTouchEnd.bind(this);
        this._onMouseStart = this._onMouseStart.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);
        this._onMouseEnd = this._onMouseEnd.bind(this);
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._onResize = debounce(this._onResize.bind(this), 100);
        this._onButtonClick = this._onButtonClick.bind(this);
        this._onDotClick = this._onDotClick.bind(this);
        this._onClickCapture = this._onClickCapture.bind(this);

        this.init();
      }

      init() {
        if (this.section.dataset.originalSlideIndex) {
          this.originalSlideIndex = parseInt(this.section.dataset.originalSlideIndex, 10);
        }

        this.cloneSlides();
        this.allSlides = Array.from(this.container.children);
        this.cacheSlidePositions();
        this.setPositionByIndex(false);
        this.bindEvents();
        this.initializeSlidersInContainer();

        if (this.totalEl && this.totalSlides > 0) {
          this.totalEl.textContent = this.totalSlides;
        }

        this.section.classList.add('is-initialised');
      }

      cacheSlidePositions() {
        if (!this.allSlides) return;

        const containerWidth = this.container.offsetWidth;
        const isMobile = window.innerWidth < 768;

        this.slidePositions = this.allSlides.map((slide) => {
          const slideWidth = slide.offsetWidth;
          
          if ((this.alignLeft && !isMobile) || (this.alignLeftMobile && isMobile)) {
            return slide.offsetLeft;
          }
          return slide.offsetLeft - (containerWidth - slideWidth) / 2;
        });
      }

      initializeSlidersInContainer() {
        const slidersToInit = this.section.querySelectorAll('[data-slider-component]:not([data-slider-initialised])');
        slidersToInit.forEach((slider) => initSlider(slider));
      }

      cloneSlides() {
        if (!this.shouldClone) {
          this.originalSlides.forEach((slide, i) => {
            this.updateCloneAttributes(slide, i);
          });
          return;
        }

        const fragment = document.createDocumentFragment();
        const fragmentEnd = document.createDocumentFragment();

        for (let i = this.originalSlides.length - this.numClones; i < this.originalSlides.length; i++) {
          const clone = this.originalSlides[i].cloneNode(true);
          this.updateCloneAttributes(clone, i);
          fragment.appendChild(clone);
        }

        for (let i = 0; i < this.numClones; i++) {
          const clone = this.originalSlides[i].cloneNode(true);
          this.updateCloneAttributes(clone, i);
          fragmentEnd.appendChild(clone);
        }

        this.container.prepend(fragment);
        this.container.append(fragmentEnd);

        this.originalSlides.forEach((slide, i) => {
          this.updateCloneAttributes(slide, i);
        });
      }

      updateCloneAttributes(slide, originalIndex) {
        slide.dataset.originalSlideIndex = originalIndex;
        slide.querySelectorAll('[data-slider-component]').forEach((innerSlider) => {
          innerSlider.dataset.originalSlideIndex = originalIndex;
        });
      }

      getSlidePosition(index) {
        if (!this.slidePositions) return 0;
        return this.slidePositions[index] || 0;
      }

      setPositionByIndex(animate = true) {
        let newTranslate;
        
        // For non-cloning sliders at max scroll, align last slide to right edge
        if (!this.shouldClone && this.currentIndex >= this.maxScrollIndex && this.maxScrollIndex > 0) {
          // Calculate position so last slide is flush against right edge
          const containerWidth = this.container.offsetWidth;
          const lastSlide = this.allSlides[this.allSlides.length - 1];
          const totalContentWidth = lastSlide.offsetLeft + lastSlide.offsetWidth;
          newTranslate = -(totalContentWidth - containerWidth);
        } else {
          newTranslate = -this.getSlidePosition(this.currentIndex);
        }

        // If position hasn't changed, don't animate (prevents stuck isAnimating)
        if (animate && newTranslate === this.currentTranslate) {
          animate = false;
        }

        this.currentTranslate = newTranslate;

        if (animate) {
          this.container.classList.add('is-animating');
          this.isAnimating = true;
        } else {
          this.container.classList.remove('is-animating');
          this.isAnimating = false;
        }

        this.setContainerPosition();
        this.updateNav();
        this.prevTranslate = this.currentTranslate;
      }

      setContainerPosition() {
        this.container.style.transform = `translateX(${this.currentTranslate}px)`;
      }

      // Interrupt animation and capture current position (for drag only)
      interruptAnimation() {
        if (this.isAnimating) {
          const style = getComputedStyle(this.container);
          const matrix = new DOMMatrix(style.transform);
          this.currentTranslate = matrix.m41;
          this.prevTranslate = this.currentTranslate;

          this.container.classList.remove('is-animating');
          this.setContainerPosition();
          this.isAnimating = false;

          // Find closest slide
          let closestIndex = this.currentIndex;
          let closestDistance = Infinity;
          this.slidePositions.forEach((pos, i) => {
            const distance = Math.abs(-pos - this.currentTranslate);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = i;
            }
          });
          this.currentIndex = closestIndex;
        }
      }

      // Touch Events
      _onTouchStart(e) {
        if (this.disableDrag) return;

        this.interruptAnimation();

        const touch = e.touches[0];
        this.startX = touch.clientX;
        this.startY = touch.clientY;
        this.isDragging = true;
        this.isLocked = false;
        this.dragDelta = 0;
        this.wasDragged = false;

        this.container.classList.remove('is-animating');
        this.container.classList.add('is-dragging');
      }

      _onTouchMove(e) {
        if (!this.isDragging) return;

        const touch = e.touches[0];
        const deltaX = touch.clientX - this.startX;
        const deltaY = touch.clientY - this.startY;

        if (!this.isLocked && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
          if (Math.abs(deltaX) > Math.abs(deltaY)) {
            this.isLocked = 'horizontal';
          } else {
            this.isLocked = 'vertical';
            this.isDragging = false;
            this.container.classList.remove('is-dragging');
            return;
          }
        }

        if (this.isLocked === 'horizontal') {
          e.preventDefault();
          this.dragDelta = deltaX;
          this.currentTranslate = this.prevTranslate + deltaX;
          this.setContainerPosition();

          if (Math.abs(deltaX) > 5) {
            this.wasDragged = true;
          }
        }
      }

      _onTouchEnd() {
        if (!this.isDragging) return;

        this.isDragging = false;
        this.container.classList.remove('is-dragging');

        if (this.isLocked === 'horizontal') {
          this.finalizeDrag();
        }
      }

      // Mouse Events
      _onMouseStart(e) {
        if (this.disableDrag) return;
        if (e.target.closest('.js-slider-prev') || e.target.closest('.js-slider-next')) return;

        this.interruptAnimation();

        e.preventDefault();
        this.startX = e.clientX;
        this.isDragging = true;
        this.isLocked = 'horizontal';
        this.dragDelta = 0;
        this.wasDragged = false;

        this.container.classList.remove('is-animating');
        this.container.classList.add('is-dragging');

        document.addEventListener('mousemove', this._onMouseMove);
        document.addEventListener('mouseup', this._onMouseEnd);
      }

      _onMouseMove(e) {
        if (!this.isDragging) return;

        const deltaX = e.clientX - this.startX;
        this.dragDelta = deltaX;
        let newTranslate = this.prevTranslate + deltaX;

        // For non-cloning sliders, clamp to prevent overscroll
        if (!this.shouldClone) {
          const minTranslate = 0; // First slide at left edge
          // Calculate max scroll position (last slide at right edge)
          const containerWidth = this.container.offsetWidth;
          const lastSlide = this.allSlides[this.allSlides.length - 1];
          const totalContentWidth = lastSlide.offsetLeft + lastSlide.offsetWidth;
          const maxTranslate = -(totalContentWidth - containerWidth);
          
          newTranslate = Math.min(minTranslate, Math.max(maxTranslate, newTranslate));
        }

        this.currentTranslate = newTranslate;
        this.setContainerPosition();

        if (Math.abs(deltaX) > 5) {
          this.wasDragged = true;
        }
      }

      _onMouseEnd() {
        if (!this.isDragging) return;

        document.removeEventListener('mousemove', this._onMouseMove);
        document.removeEventListener('mouseup', this._onMouseEnd);

        this.isDragging = false;
        this.container.classList.remove('is-dragging');
        this.finalizeDrag();
      }

      _onClickCapture(e) {
        if (this.wasDragged) {
          e.preventDefault();
          e.stopPropagation();
          setTimeout(() => {
            this.wasDragged = false;
          }, 0);
        }
      }

      finalizeDrag() {
        const slideWidth = this.allSlides[0]?.offsetWidth || 300;
        const threshold = slideWidth * 0.2;

        if (this.dragDelta < -threshold) {
          // Prevent going past maxScrollIndex when not cloning
          if (!this.shouldClone && this.currentIndex >= this.maxScrollIndex) {
            // Stay at current position
          } else {
            this.currentIndex++;
          }
        } else if (this.dragDelta > threshold) {
          // Prevent going before the first slide when not cloning
          if (!this.shouldClone && this.currentIndex <= 0) {
            // Stay at current position
          } else {
            this.currentIndex--;
          }
        }

        this.loadSlideImages();
        this.setPositionByIndex(true);
        this.syncWithClones();
      }

      _onButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();

        // Don't allow clicks while animating
        if (this.isAnimating) return;

        const button = e.currentTarget;

        if (button.classList.contains('js-slider-prev')) {
          // Prevent going before the first slide when not cloning
          if (!this.shouldClone && this.currentIndex <= 0) return;
          this.currentIndex--;
        } else {
          // Prevent going past maxScrollIndex when not cloning
          if (!this.shouldClone && this.currentIndex >= this.maxScrollIndex) return;
          this.currentIndex++;
        }

        this.loadSlideImages();
        this.setPositionByIndex(true);
        this.syncWithClones();
      }

      _onDotClick(e) {
        const dot = e.target.closest('.js-slider-dot');
        if (!dot) return;

        e.stopPropagation();

        if (this.isAnimating) return;

        const index = parseInt(dot.dataset.index, 10);
        this.currentIndex = index + this.numClones;
        this.loadSlideImages();
        this.setPositionByIndex(true);
        this.syncWithClones();
      }

      loadSlideImages() {
        const slidesToLoad = Math.ceil(this.slidesToShow) + 1;
        const startIndex = Math.max(0, this.currentIndex - slidesToLoad);
        const endIndex = Math.min(this.allSlides.length - 1, this.currentIndex + slidesToLoad);

        for (let i = startIndex; i <= endIndex; i++) {
          const images = this.allSlides[i]?.querySelectorAll('img:not([src])');
          images?.forEach((image) => {
            if (image.dataset.src) image.src = image.dataset.src;
          });
        }
      }

      next() {
        if (this.isAnimating) return;
        this.currentIndex++;
        this.loadSlideImages();
        this.setPositionByIndex(true);
        this.syncWithClones();
      }

      prev() {
        if (this.isAnimating) return;
        this.currentIndex--;
        this.loadSlideImages();
        this.setPositionByIndex(true);
        this.syncWithClones();
      }

      updateNav() {
        if (!this.allSlides) return;

        const displayIndex =
          (((this.currentIndex - this.numClones) % this.totalSlides) + this.totalSlides) % this.totalSlides;

        if (this.currentEl) this.currentEl.textContent = displayIndex + 1;

        this.dots?.forEach((dot, i) => dot.classList.toggle('is-active', i === displayIndex));

        this.allSlides.forEach((slide) => slide.classList.remove('is-active'));
        this.allSlides[this.currentIndex]?.classList.add('is-active');

        this.handleVideoPlayback();
      }

      handleVideoPlayback() {
        if (!this.allSlides) return;

        // DEBUGGING: render 'new-slider-test-video' in index.liquid to test

        this.allSlides.forEach((slide, index) => {
          const videos = slide.querySelectorAll('video');
          videos.forEach((video) => {
            if (index !== this.currentIndex) {
              video.pause();
            }
          });
        });

        const activeSlide = this.allSlides[this.currentIndex];

        if (activeSlide) {
          const video = activeSlide.querySelector('video');
          if (video) {
            video.muted = true;
            video.playsInline = true;

            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Autoplay was prevented - video stays paused
              });
            }
          }
        }
      }

      _onTransitionEnd(e) {
        if (e.target !== this.container) return;

        this.isAnimating = false;
        this.container.classList.remove('is-animating');

        // Only perform wrap-around when cloning is enabled
        if (!this.shouldClone) return;

        if (this.currentIndex < this.numClones) {
          this.currentIndex += this.originalSlides.length;
          this.currentTranslate = -this.getSlidePosition(this.currentIndex);
          this.prevTranslate = this.currentTranslate;
          this.setContainerPosition();
          this.updateNav();
        } else if (this.currentIndex >= this.originalSlides.length + this.numClones) {
          this.currentIndex -= this.originalSlides.length;
          this.currentTranslate = -this.getSlidePosition(this.currentIndex);
          this.prevTranslate = this.currentTranslate;
          this.setContainerPosition();
          this.updateNav();
        }
      }

      syncWithClones() {
        if (this.originalSlideIndex === undefined || this.originalSlideIndex === -1) return;

        const otherSliders = document.querySelectorAll(
          `[data-slider-component][data-original-slide-index="${this.originalSlideIndex}"]`
        );

        otherSliders.forEach((otherSliderEl) => {
          const instance = otherSliderEl.sliderInstance;
          if (instance && instance !== this && instance.currentIndex !== this.currentIndex) {
            instance.goTo(this.currentIndex, false);
          }
        });
      }

      goTo(index, animate = true) {
        this.currentIndex = index;
        this.setPositionByIndex(animate);
      }

      _onResize() {
        this.slidesToShow = parseFloat(getComputedStyle(this.section).getPropertyValue('--slides-to-show')) || 1;
        this.cacheSlidePositions();
        this.setPositionByIndex(false);
      }

      bindEvents() {
        this.section.dataset.sliderInitialised = 'true';

        this.section.addEventListener('touchstart', this._onTouchStart, { passive: true });
        this.section.addEventListener('touchmove', this._onTouchMove, { passive: false });
        this.section.addEventListener('touchend', this._onTouchEnd, { passive: true });
        this.section.addEventListener('touchcancel', this._onTouchCancel, { passive: true });

        this.section.addEventListener('mousedown', this._onMouseStart);

        this.section.addEventListener('click', this._onClickCapture, true);

        this.prevButton?.addEventListener('click', this._onButtonClick);
        this.nextButton?.addEventListener('click', this._onButtonClick);

        this.dots.forEach((dot) => dot.addEventListener('click', this._onDotClick));

        this.container.addEventListener('transitionend', this._onTransitionEnd);

        window.addEventListener('resize', this._onResize);

        this.loadSlideImages();
      }

      destroy() {
        // Remove window/document listeners
        window.removeEventListener('resize', this._onResize);
        document.removeEventListener('mousemove', this._onMouseMove);
        document.removeEventListener('mouseup', this._onMouseEnd);

        // Remove section listeners
        this.section.removeEventListener('touchstart', this._onTouchStart);
        this.section.removeEventListener('touchmove', this._onTouchMove);
        this.section.removeEventListener('touchend', this._onTouchEnd);
        this.section.removeEventListener('touchcancel', this._onTouchCancel);
        this.section.removeEventListener('mousedown', this._onMouseStart);
        this.section.removeEventListener('click', this._onClickCapture, true);

        // Remove button listeners
        this.prevButton?.removeEventListener('click', this._onButtonClick);
        this.nextButton?.removeEventListener('click', this._onButtonClick);

        // Remove dot listeners
        this.dots.forEach((dot) => dot.removeEventListener('click', this._onDotClick));

        // Remove container listener
        this.container.removeEventListener('transitionend', this._onTransitionEnd);

        this.section.sliderInstance = null;
      }
    }

    function initSlider(section) {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      const isDisabledOnDesktop = section.dataset.sliderDisableOnDesktop === 'true';

      if (isDesktop && isDisabledOnDesktop) {
        section.classList.add('is-initialised');
        section.dataset.sliderInitialised = 'true';
        return;
      }

      if (!section.sliderInstance) {
        section.sliderInstance = new SeamlessSlider(section);
      }
    }

    document.querySelectorAll('[data-slider-component]:not([data-slider-initialised])').forEach(initSlider);

    window.initSlider = initSlider;

    // Collection slider logic
    window.initSearchspringSliders = () => {
      const collectionSliders = document.querySelectorAll('.new-collection-slider');

      const calculateCollectionSliderHeights = () => {
        requestAnimationFrame(() => {
          collectionSliders.forEach((slider) => {
            const slideContainers = slider.querySelectorAll('.new-collection-slide');
            let maxHeight = 0;
            slider.style.minHeight = '';

            slideContainers.forEach((slide) => {
              const slideHeight = slide.offsetHeight;
              if (slideHeight > maxHeight) maxHeight = slideHeight;
            });

            if (maxHeight > 0) slider.style.minHeight = `${maxHeight}px`;
          });
        });
      };

      calculateCollectionSliderHeights();
      window.addEventListener('resize', debounce(calculateCollectionSliderHeights, 100));

      collectionSliders.forEach((slider) => {
        const titles = slider.querySelectorAll('.js-collection-slider-title');

        titles.forEach((title) => {
          title.addEventListener('click', () => {
            if (title.classList.contains('is-active')) return;

            const index = title.dataset.index;
            const activeSlide = slider.querySelector('.new-collection-slide.is-active');
            const nextSlide = slider.querySelector(`.new-collection-slide[data-index="${index}"]`);

            if (!nextSlide) return;

            titles.forEach((t) => t.classList.remove('is-active'));
            title.classList.add('is-active');

            activeSlide?.classList.remove('is-active');
            nextSlide.classList.add('is-active');

            nextSlide.querySelectorAll('[data-slider-component]').forEach((innerSlider) => {
              if (innerSlider.sliderInstance) {
                innerSlider.sliderInstance.cacheSlidePositions();
                innerSlider.sliderInstance.setPositionByIndex(false);
              }
            });
          });
        });
      });

      // Searchspring slider builder
      const buildSliderComponentHTML = (slidesHTML, options) => {
        const { alignLeft, disableDrag, slideCount, showControls, countOnDesktop, disableOnDesktop, urgencyBannersHTML } =
          options;
        return `
          <div class="slider-component slider-component--searchspring js-new-slider-component" data-slider-component
            ${disableOnDesktop ? 'data-slider-disable-on-desktop="true"' : ''}
            ${showControls === false ? 'data-slider-disable-controls-on-mobile="true"' : ''}
            ${countOnDesktop ? 'data-slider-count-on-desktop="true"' : ''}
            ${alignLeft ? 'data-slider-align-left="true"' : ''}
            ${options.alignLeftMobile ? 'data-slider-align-left-mobile="true"' : ''}
            ${options.hideCount ? 'data-slider-hide-count="true"' : ''}
            ${disableDrag ? 'data-slider-disable-drag="true"' : ''}
          >
            <div class="slider__container js-slider">${slidesHTML}</div>
            <button class="slider__nav-button slider__nav-button--prev js-slider-prev" aria-label="Previous slide">
              <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                <polyline points="4,2 8,6 4,10" fill="none" stroke="currentColor" stroke-width="1"/>
              </svg>
            </button>
            <button class="slider__nav-button slider__nav-button--next js-slider-next" aria-label="Next slide">
              <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                <polyline points="4,2 8,6 4,10" fill="none" stroke="currentColor" stroke-width="1"/>
              </svg>
            </button>
            ${showControls !== false ? '<div class="slider__controls"></div>' : ''}
            <span class="slider__count">
              <span class="js-slider-current">1</span>/
              <span class="js-slider-total">${slideCount}</span>
            </span>
            ${urgencyBannersHTML || ''}
          </div>
        `;
      };

      /**
       * Formats a price number into the shop's money format string.
       * Applies the active Shopify currency rate when the visitor is
       * browsing in a non-default currency.
       * @param {number|string} price - Raw price value (in default currency)
       * @param {string} format - Shopify money_format string
       * @returns {string} Formatted price HTML
       */
      const formatMoney = (price, format) => {
        const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
        let cents;
        if (rate !== 1) {
          const raw = parseFloat(price) * rate;
          cents = Math.ceil(parseFloat(raw.toFixed(2)));
        } else {
          cents = parseFloat(price);
        }
        const amount = cents.toFixed(2);
        const amountNoDecimals = cents.toString();
        const amountWithCommaSeparator = amount.replace('.', ',');
        const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithCommaSeparator)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimalsWithCommaSeparator)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
          .replace(/\{\{\s*amount\s*\}\}/, amount);
      };

      const getSpinnerHTML = () =>
        `<div class="new-product-card-sizes__spinner"><svg aria-hidden="true" focusable="false" class="icon icon-spinner" viewBox="0 0 20 20"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" pathLength="100" stroke-dasharray="75 25"/></svg></div>`;

      const buildProductLabelsHTML = (productAttributes) => {
        if (!productAttributes || !productAttributes.ss_badge_text) {
          return '';
        }

        const badgeColour = productAttributes.ss_badge_colour || '#000000';
        const badgeBg = productAttributes.ss_badge_bg || '#ffffff';

        const bannersHTML = `<span class="urgency-banner" style="background-color: ${badgeBg}; color: ${badgeColour};">${productAttributes.ss_badge_text}</span>`;

        return `<div class="urgency-banners-container">${bannersHTML}</div>`;
      };

      const buildSizesBoxHTML = (product, countryCode) => {
        const sizesString = product.attributes.ss_sizes;
        if (!sizesString) return '';

        let variants;
        try {
          variants = JSON.parse(sizesString);
        } catch {
          return '';
        }

        if (!Array.isArray(variants) || variants.length === 0) return '';

        const sizeButtons = variants
          .map((variant) => {
            const size =
              variant.label === 'One Size' ? variant.label : variant.label?.split(' ').pop()?.trim() || variant.label;
            const isUnavailable = variant.available <= 0;
            return `<button data-variant-id="${variant.id}" class="new-product-card-sizes__size js-product-card-size ${
              isUnavailable ? 'new-product-card-sizes__size--is-unavailable' : ''
            }" ${isUnavailable ? 'disabled' : ''}>${size}</button>`;
          })
          .join('');

        return `<div class="new-product-card-sizes js-product-card-sizes">${getSpinnerHTML()}<span class="new-product-card-sizes__size-unit">${countryCode}</span>${sizeButtons}</div>`;
      };

      /**
       * Builds price HTML for a Searchspring product card.
       * Currency conversion is handled automatically by formatMoney
       * using Shopify.currency.rate.
       * @param {Object} product - Searchspring result object
       * @param {string} moneyFormat - Shopify money format string
       * @returns {string} Price HTML string
       */
      const buildPriceHTML = (product, moneyFormat) => {
        const price = product.mappings?.core?.price;
        const msrp = product.msrp || product.mappings?.core?.msrp;
        const saleBool = product.ss_on_sale || product.attributes?.ss_on_sale;
        const isOnSale = (saleBool === '1' || saleBool === 1) && price && msrp && Number(msrp) > Number(price);

        if (isOnSale) {
          return `<span class="new-collection-slide__prices">
            <span class="new-collection-slide__price new-collection-slide__price--sale">${formatMoney(price, moneyFormat)}</span>
            <span class="new-collection-slide__price new-collection-slide__price--was">${formatMoney(msrp, moneyFormat)}</span>
          </span>`;
        }

        return `<span class="new-collection-slide__price">${formatMoney(price, moneyFormat)}</span>`;
      };

      const buildProductSlides = (results, countryCode, moneyFormat, options = {}) => {
        const isMinimal = options.minimal || false;

        return results
          .map((product) => {
            const productLabelsHTML = buildProductLabelsHTML(product.attributes);

            let imageHTML;
            if (isMinimal) {
              // Minicart: single image, no inner slider
              const image = product.attributes.ss_images?.[0] || product.mappings.core.thumbnailImageUrl;
              imageHTML = `<div class="slider-component slider-component--searchspring is-initialised slider--no-scroll" style="--slides-to-show: 1;">
                <div class="slider__container js-slider">
                  <img src="${image}" alt="${product.mappings.core.name.replace(/"/g, '&quot;')}" draggable="false" loading="lazy">
                </div>
                ${productLabelsHTML ? productLabelsHTML : ''}
              </div>`;
            } else {
              const images = product.attributes.ss_images || [product.mappings.core.thumbnailImageUrl];
              const imageSlides = images
                .map(
                  (image, index) =>
                    `<img ${
                      index === 0 ? `src="${image}"` : ''
                    } data-src="${image}" alt="${product.mappings.core.name.replace(
                      /"/g,
                      '&quot;'
                    )}" draggable="false" loading="lazy">`
                )
                .join('');

              imageHTML = buildSliderComponentHTML(imageSlides, {
                disableDrag: true,
                slideCount: images.length,
                showControls: false,
                countOnDesktop: false,
                disableOnDesktop: false,
                urgencyBannersHTML: productLabelsHTML,
              });
            }

            const sizesBoxHTML = isMinimal ? '' : buildSizesBoxHTML(product, countryCode);

            // In minicart: resolve the first available variant ID for quick add-to-cart
            let quickAddAttrs = '';
            if (isMinimal) {
              let firstVariantId = null;
              try {
                const variants = JSON.parse(product.attributes.ss_sizes || '[]');
                const available = variants.find((v) => v.available > 0);
                firstVariantId = available?.id || variants[0]?.id || null;
              } catch { /* ignore parse failures */ }

              if (firstVariantId) {
                quickAddAttrs = ` data-quick-add data-variant-id="${firstVariantId}"`;
              }
            }

            return `<a class="new-collection-slide__item js-new-slider-item" href="${
              product.mappings.core.url
            }" draggable="false"${quickAddAttrs}>
            ${imageHTML}
            <button aria-label="Add to Wishlist" class="js-add-to-wishlist add-to-wishlist-button swym-heart swym-add-to-wishlist-view-product swym-loaded swym-collections" data-product-url="${
              window.location.origin
            }${product.mappings.core.url}" data-product-id="${product.id}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
            </button>
            ${sizesBoxHTML}
            <div class="new-collection-slide__info">
              <span class="new-collection-slide__title">${product.mappings.core.name}</span>
              ${buildPriceHTML(product, moneyFormat)}
            </div>
          </a>`;
          })
          .join('');
      };

      document.querySelectorAll('.searchspring-slider-placeholder').forEach((placeholder) => {
        const searchspringId = placeholder.dataset.searchspringId;
        const countryCode = placeholder.dataset.countryCode;
        const moneyFormat = placeholder.dataset.moneyFormat;
        const productSku = placeholder.dataset.productSku;
        const shopperId = placeholder.dataset.shopperId;
        if (!searchspringId || !window.ss_site_id) return;

        // Detect if placeholder is inside the minicart for minimal rendering
        const isMinicart = !!placeholder.closest('.new-minicart');

        const handleSearchspringResponse = (data, isFallback = false) => {
          const panel = placeholder.closest('.new-collection-slide');
          const section = placeholder.closest('.new-collection-slider');

          // If no results for recently-viewed sliders, fallback
          if (!data?.[0]?.results?.length) {
            const altSearchspringId = placeholder.dataset.altSearchspringId;
            const altTitle = placeholder.dataset.altTitle;

            // Try fallback if alt_searchspring_id is configured (only once to avoid infinite loop)
            if (altSearchspringId && !isFallback) {
              const fallbackUrl = `https://${window.ss_site_id}.a.searchspring.io/boost/${window.ss_site_id}/recommend?tags=${altSearchspringId}`;

              // Update tab button title to reflect fallback content if alt_title is set
              if (altTitle && panel && section) {
                const panelIndex = panel.dataset.index;
                const tabButton = section.querySelector(`.js-collection-slider-title[data-index="${panelIndex}"]`);
                if (tabButton) tabButton.textContent = altTitle;
              }

              fetch(fallbackUrl)
                .then((res) => res.json())
                .then((fallbackData) => handleSearchspringResponse(fallbackData, true))
                .catch((err) => console.error('Searchspring fallback error:', err));
              return;
            }

            // No results and no fallback available - hide the panel and tab
            if (panel && section) {
              const panelIndex = panel.dataset.index;
              panel.style.display = 'none';
              // Find and hide the corresponding tab button within the same section
              const tabButton = section.querySelector(`.js-collection-slider-title[data-index="${panelIndex}"]`);
              if (tabButton) {
                tabButton.style.display = 'none';
                // If this was the active tab, activate the next available one
                if (tabButton.classList.contains('is-active')) {
                  tabButton.classList.remove('is-active');
                  panel.classList.remove('is-active');
                  const nextTab = section.querySelector('.js-collection-slider-title:not([style*="display: none"])');
                  const nextPanel = section.querySelector('.new-collection-slide:not([style*="display: none"])');
                  if (nextTab) nextTab.classList.add('is-active');
                  if (nextPanel) nextPanel.classList.add('is-active');
                }
              }
            }
            return;
          }

          const results = data[0].results;
          const showControls = placeholder.dataset.showControls === 'true';
          const alignLeft = placeholder.dataset.alignLeft === 'true';

          const outerSliderHTML = buildSliderComponentHTML(
            buildProductSlides(results, countryCode, moneyFormat, { minimal: isMinicart }),
            {
              alignLeft: alignLeft || true, 
              alignLeftMobile: placeholder.dataset.alignLeftMobile === 'true',
              hideCount: placeholder.dataset.hideCount === 'true',
              slideCount: results.length,
              showControls: showControls,
              disableOnDesktop: false,
              countOnDesktop: false,
            }
          );

          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = outerSliderHTML;
          const newSliderElement = tempDiv.firstElementChild;
          placeholder.replaceWith(newSliderElement);
          initSlider(newSliderElement);

          // Dispatch event to let other components know the slider is ready
          newSliderElement.dispatchEvent(
            new CustomEvent('searchspring:slider:initialized', {
              bubbles: true,
              detail: { slider: newSliderElement },
            })
          );

          calculateCollectionSliderHeights();
        };

        let apiUrl = `https://${window.ss_site_id}.a.searchspring.io/boost/${window.ss_site_id}/recommend?tags=${searchspringId}`;

        // Add product context for product-specific recommendations (e.g., customers-also-viewed)
        if (productSku) {
          apiUrl += `&products=${encodeURIComponent(productSku)}`;
        }

        // Add shopper ID for personalised ordering
        if (shopperId) {
          apiUrl += `&shopper=${encodeURIComponent(shopperId)}`;
        }

        if (searchspringId === 'recently-viewed' || searchspringId === 'pdp-recently-viewed') {
          try {
            const ssViewed = JSON.parse(localStorage.getItem('ssViewedProducts') || '{}');
            if (ssViewed?.value && Array.isArray(ssViewed.value)) {
              const uids = ssViewed.value
                .map((item) => item.uid)
                .filter(Boolean)
                .filter((uid, index, self) => self.indexOf(uid) === index)
                .slice(0, 15)
                .join(',');

              if (!uids) {
                handleSearchspringResponse([{ results: [] }]);
                return;
              }
              apiUrl += `&lastViewed=${encodeURIComponent(uids)}`;
            } else {
              handleSearchspringResponse([{ results: [] }]);
              return;
            }
          } catch (e) {
            console.error('Error parsing ssViewedProducts:', e);
            handleSearchspringResponse([{ results: [] }]);
            return;
          }
        }

        fetch(apiUrl)
          .then((res) => res.json())
          .then(handleSearchspringResponse)
          .catch((err) => console.error('Searchspring error:', err));
      });
    };

    document.addEventListener('DOMContentLoaded', window.initSearchspringSliders);
  })();
  } catch(e) { console.error(e); }
})();

})();
